// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"withBackWrap_wrapper__1zzLa","backToTopBtn":"withBackWrap_backToTopBtn__y5Rrg","downAppBtn":"withBackWrap_downAppBtn__3v907"};